import { logWithBadge } from './logging'

let updateId: any

export function removeServiceWorker() {
  logWithBadge('sw', 'removeServiceWorker')
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      if (registrations.length > 0) {
        logWithBadge('sw', 'removing service workers')
      }
      for (const registration of registrations) {
        registration.unregister()
      }
    })
  }
}

export function cancelServiceWorkerUpdate() {
  clearTimeout(updateId)
}
